//@flow
import * as Immutable from 'immutable';

import { PjpGraphResponse } from 'common/models/flow/PjpGraphResponse';
import type { PjpGraphResponseModelType } from 'common/models/flow/PjpGraphResponse';
import { PjpMetricData } from 'common/models/internal/PjpMetricResponse';

class InternalPjpGraphResponse extends PjpGraphResponse {
    static fromJS(json: PjpGraphResponseModelType): InternalPjpGraphResponse {
        const state: Object = Object.assign({}, json);
        state.metricsData = Immutable.List(state.metricsData).map(item =>
            PjpMetricData.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

export { InternalPjpGraphResponse as PjpGraphResponse };
